export const CONTACT_EMAIL = 'romanstorck14@gmail.com'

export const ROL_WAARDEN: Array<string> = ['Leerkracht', 'Directeur', 'Schoolbestuur', 'Ouder']

export const GROEPEN: Array<string> = ['3', '4', '5', '6', '7', '8']

export const WENSEN: Array<string> = [
    "Voorlezen met een natuurlijke stem",
    "Teksten op niveau per leerling",
    "Meer themaweken",
    "Ouders laten meekijken",
    "Koppeling met ons leerlingvolgsysteem",
    "Thema’s die aansluiten bij wereldoriëntatie",
    "Voortgang per leerling over het hele jaar"
]
